import React from 'react';
import PropTypes from 'prop-types';
import { S } from './style';
const isString = (value) => typeof value === 'string';
export default function Config({ APP, EXTERNAL_LINK_URL }) {
    const appConfig = {
        name: APP.NAME,
        versionCommitSHA: APP.VERSION_COMMIT_SHA,
        versionCommitDate: APP.VERSION_COMMIT_DATE,
        versionBranch: APP.VERSION_BRANCH,
        buildDate: APP.BUILD_DATE,
        routes: APP.ROUTES,
    };
    const externalLinKUrlConfig = {
        externalLinKUrl: EXTERNAL_LINK_URL,
    };
    return (<S.Wrapper>
      <h3>App 資訊</h3>
      {Object.entries({ ...appConfig, ...externalLinKUrlConfig }).map(([key, value]) => (<S.Block key={key}>
          <S.Title>{key}</S.Title>
          <S.Config>{isString(value) ? value : JSON.stringify(value)}</S.Config>
        </S.Block>))}
    </S.Wrapper>);
}
Config.propTypes = {
    APP: PropTypes.shape({
        NAME: PropTypes.string.isRequired,
        VERSION_COMMIT_SHA: PropTypes.string.isRequired,
        VERSION_COMMIT_DATE: PropTypes.string.isRequired,
        VERSION_BRANCH: PropTypes.string.isRequired,
        BUILD_DATE: PropTypes.string.isRequired,
        ROUTES: PropTypes.shape({}),
    }),
    EXTERNAL_LINK_URL: PropTypes.shape({}),
};
